import WorkspaceSettings from "../presentation/views/WorkspaceSettings.vue";
export const workspaceRoutes = [
    {
        path: "/workspace/settings",
        name: "WorkspaceSettings",
        component: WorkspaceSettings,
        meta: { requiresAuth: true, titleKey: "workspace.settings.title" },
    },
];
export const workspaceNavigationItems = [
    {
        labelKey: "workspace.title",
        children: [
            {
                labelKey: "workspace.settings.title",
                path: "/workspace/settings",
                meta: { requiresAuth: true },
            },
        ],
    },
];
